import { render } from "./RicettaComponent.vue?vue&type=template&id=07ab6cad&scoped=true"
import script from "./RicettaComponent.vue?vue&type=script&lang=js"
export * from "./RicettaComponent.vue?vue&type=script&lang=js"

import "./RicettaComponent.vue?vue&type=style&index=0&id=07ab6cad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ab6cad"]])

export default __exports__